import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "@uranda/commons";
import { CreateContactRequest } from "../../../models/requests/createContactRequest.model";
import { CreateOfferRequest } from "../../../models/requests/createLeadRequest.model";
import { ActiveQuoteRequestStatus } from "../../../models/requests/activeQuoteRequest.model";

@Injectable({
  providedIn: 'root'
})
export class RequestService extends ApiService {

  async createContactRequest(request: CreateContactRequest) {
    const response = await this.post('/v1/requests/contact/create', request)
    return response.data;
  }

  async getActiveQuoteRequest(phoneNumber: string): Promise<ActiveQuoteRequestStatus> {
    const queryParameters = new HttpParams().set('phoneNumber', phoneNumber);
    const response = await this.get('/v1/requests/quote/active-request', queryParameters);
    return response.data as ActiveQuoteRequestStatus;
  }

  async resendAccessLink(phoneNumber: string): Promise<void> {
    await this.post('/v1/requests/quote/resend-access-link', { phoneNumber });
  }

  async createOfferRequest(
    countryId?: string,
    regionId?: string,
    provinceId?: string,
    panoramicPhoto1?: File | null,
    panoramicPhoto2?: File | null,
    otherImages?: Blob[] | null,
    request?: any
  ) {
    const formData = new FormData();

    if (panoramicPhoto1) {
      formData.append('panoramicPhoto1', panoramicPhoto1, panoramicPhoto1.name);
    }

    if (panoramicPhoto2) {
      formData.append('panoramicPhoto2', panoramicPhoto2, panoramicPhoto2.name);
    }

    if (otherImages?.length) {
      otherImages.forEach((blob: Blob, index: number) => {
        formData.append('otherImages', blob, `image_${index}.jpg`);
      });
    }

    formData.append('data', new Blob([JSON.stringify(this.mapToRequestModel(request, countryId || '', regionId, provinceId))], { type: 'application/json' }));


    const response = await this.post('/v1/requests/quote/create', formData);
    return response.data;
  }

  async completeQuoteRequest(
    token: string,
    panoramicPhoto1?: File | null,
    panoramicPhoto2?: File | null,
    otherImages?: Blob[] | null,
    request?: any,
    countryId?: string,
    regionId?: string,
    districtId?: string
  ) {
    const formData = new FormData();

    if (panoramicPhoto1) {
      formData.append('panoramicPhoto1', panoramicPhoto1, panoramicPhoto1.name);
    }
    if (panoramicPhoto2) {
      formData.append('panoramicPhoto2', panoramicPhoto2, panoramicPhoto2.name);
    }
    if (otherImages?.length) {
      otherImages.forEach((blob: Blob, index: number) => {
        formData.append('otherImages', blob, `image_${index}.jpg`);
      });
    }
    formData.append('data', new Blob([JSON.stringify(this.mapToRequestModel(request, countryId || '', regionId, districtId))], { type: 'application/json' }));

    const response = await this.put(`/v1/requests/quote/complete?token=${encodeURIComponent(token)}`, formData);
    return response.data;
  }

  mapToRequestModel(formModel: any, countryId: string, regionId?: string, districtId?: string): CreateOfferRequest {
    return {
      lead: {
        firstname: formModel.firstname,
        lastname: formModel.lastname,
        address: formModel.address,
        city: formModel.cityId,
        country: JSON.stringify(formModel.location),
        phoneNumber: formModel.phoneNumber,
        email: formModel.email
      },
      offerDetails: {
        dentalArch: formModel.dentalArch,
        treatmentType: formModel.treatmentType,
        requestDetails: formModel.requestDetails,
        requestMotivation: formModel.requestMotivation,
        countryId: countryId,
        districtId: districtId,
        regionId: regionId
      }
    };
  }

}
